import { bizNoFieldText, bizNoInputValue } from '@/utils/bizNumber'
import { telDigits, telFieldText, telText } from '@/utils/telNumber'
import { formatKst, shiftKst } from '@/utils/kstDate'

export const util = {
  inputBusiNum: function (val) {
    val = '' + val
    return val.replace(/[^0-9-\s]/g, '')
  },
  inputBusiNumNew: function (val) {
    val.target.value = '' + val.target.value
    return val.target.value.replace(/[^0-9-\s]/g, '')
  },
  /**
   * 사업자등록번호 칸 — `:value="util.bizNoFieldText(v)"` 로 치는 대로 000-00-00000 으로 끊어 보이고,
   * `@input="v = util.bizNoInputValue($event)"` 로 서버에는 숫자만 보낸다(사람이 친 `-` 는 버린다 · `utils/bizNumber`).
   * 그 칸을 고치지 않으면 저장 값도 그대로다. 계좌번호 칸은 위 `inputBusiNumNew` 를 그대로 쓴다
   */
  bizNoFieldText: bizNoFieldText,
  bizNoInputValue: bizNoInputValue,
  /**
   * 전화·팩스·휴대폰 칸 — `:value="util.telFieldText(v)"` 로 치는 대로 번호 종류대로 끊어 보이고(02-123-4567 · 010-1234-5678 ·
   * 1588-1234), `@input="v = util.telDigits($event)"` 로 서버에는 숫자만 보낸다(사람이 친 `-` 는 버린다 · `utils/telNumber`).
   * 그 칸을 고치지 않으면 저장 값도 그대로다
   */
  telFieldText: telFieldText,
  telDigits: telDigits,
  /** 표의 전화·팩스 칸 — `:formatter="util.telCell"`. 다 친 번호는 번호 종류로 끊고, 알아보지 못한 값은 받은 그대로(`telNumber.telText`) */
  telCell: function (row, column, cellValue) {
    return telText(cellValue)
  },
  /* 수자 */
  inputNum: function (val) {
    val = '' + val // 텍스트 입력 폼이지만 수자만 있을 시 스크립트 변수는 Num으로 들어올수 있음
    return val.replace(/[^0-9]/g, '')
  },
  /* 숫자 */
  inputNumNew: function (val) {
    val.target.value = '' + val.target.value
    return val.target.value.replace(/[^0-9]/g, '')
  },
  /* 이미지 2 Base64 */
  imgToBase64: function (url, outputFormat, callback) {
    var canvas = document.createElement('CANVAS'),
      ctx = canvas.getContext('2d'),
      img = new Image()
    img.onload = function () {
      canvas.height = img.height
      canvas.width = img.width
      ctx.drawImage(img, 0, 0)
      var dataURL = canvas.toDataURL(outputFormat || 'image/png')
      callback(dataURL, img)
      canvas = null
    }
    img.src = url
  },
  copyObj: function (obj) {
    return JSON.parse(JSON.stringify(obj))
  },
  /**
   * 지금을 **KST** 로 적는다 — 형식 문법과 규칙은 `utils/kstDate` 한 곳(`formatKst`). 보는 사람의 시간대가 끼어들면 기본
   * 조회 기간이 하루 어긋난다(R-K2 J7).
   */
  getNow: function (fmt) {
    return formatKst(fmt, Date.now())
  },
  /** 그 순간을 **KST** 로 적는다([getNow] 와 같은 문법) */
  getDate: function (fmt, date) {
    return formatKst(fmt, date.getTime())
  },
  /**
   * 날자 계산 — **KST 달력**으로 옮긴 새 `Date`(간격 어휘는 `utils/kstDate` 의 `shiftKst`). 넘긴 `date` 는 바꾸지 않는다.
   * 날짜를 주지 않으면 지금이다.
   */
  dateAdd: function (interval, number, date) {
    const base = this.isEmpty(date) ? Date.now() : date.getTime()

    return new Date(shiftKst(interval, number, base))
  },
  isEmpty: function (v) {
    if (null == v || typeof v == 'undefined' || 'undefined' == v || '' == v) {
      return true
    } else {
      return false
    }
  },
  isArray: function (v) {
    if (v instanceof Array) {
      return true
    } else {
      return false
    }
  },
  formatMoney: function (money) {
    var m = 0

    if (!this.isEmpty(money)) {
      m = money
        .toFixed(1)
        .replace(/(\d)(?=(\d{3})+\.)/g, '$1,')
        .replace('.0', '')
    }

    return m
  },
  /* Cookie 저장 */
  setCookie: function (c_name, value, expiredays) {
    this.delCookie(c_name)

    var exdate = new Date()
    exdate.setDate(exdate.getDate() + expiredays)
    document.cookie =
      c_name + '=' + escape(value) + (expiredays == null ? '' : ';expires=' + exdate.toGMTString()) + ';path=/;'
  },
  /* Cookie 값 가져오기 */
  getCookie: function (c_name) {
    if (document.cookie.length > 0) {
      var c_start = document.cookie.indexOf(c_name + '=')

      if (c_start != -1) {
        c_start = c_start + c_name.length + 1
        var c_end = document.cookie.indexOf(';', c_start)

        if (c_end == -1) c_end = document.cookie.length

        return unescape(document.cookie.substring(c_start, c_end))
      }
    }

    return ''
  },
  /* Cookie 삭제 */
  delCookie: function (c_name) {
    var exdate = new Date()
    exdate.setTime(exdate.getTime() - 1)
    var value = this.getCookie(c_name)
    if (value != null) document.cookie = c_name + '=' + escape(value) + ';expires=' + exdate.toGMTString() + ';path=/;'
  },
}

export default {
  data() {
    return {
      util,
    }
  },
}
